import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { StockingServiceService } from '../stocking-service.service';
import { NotificationService } from 'src/app/shared/notification.service';

interface ProductTypeRow {
  key: string;
  category: string;
}

@Component({
  selector: 'app-product-types',
  templateUrl: './product-types.component.html',
  styleUrls: ['./product-types.component.css']
})
export class ProductTypesComponent implements OnInit {

  rows: ProductTypeRow[] = [];
  loading = true;
  saving = false;

  constructor(
    private stockingService: StockingServiceService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.stockingService.getProductTypesOrdered().subscribe(rows => {
      this.rows = rows.map(row => ({ ...row }));
      this.loading = false;
    });
  }

  get categories(): string[] {
    return Array.from(new Set(this.rows.map(r => r.category).filter(c => !!c)))
      .sort((a, b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()));
  }

  get hasDuplicateKeys(): boolean {
    const keys = this.rows.map(r => r.key.trim()).filter(k => !!k);
    return new Set(keys).size !== keys.length;
  }

  drop(event: CdkDragDrop<ProductTypeRow[]>) {
    moveItemInArray(this.rows, event.previousIndex, event.currentIndex);
  }

  addRow() {
    this.rows.push({ key: '', category: '' });
  }

  removeRow(index: number) {
    this.rows.splice(index, 1);
  }

  save() {
    if (this.hasDuplicateKeys) {
      this.notificationService.showNotification('warning', 'Product type names must be unique.');
      return;
    }

    const validRows = this.rows
      .map(row => ({ key: row.key.trim(), category: row.category.trim() }))
      .filter(row => row.key && row.category);

    this.saving = true;
    this.stockingService.saveProductTypes(validRows).then(() => {
      this.saving = false;
      this.notificationService.showNotification('success', 'Product types saved.');
    }).catch(error => {
      this.saving = false;
      console.error(error);
      this.notificationService.showNotification('error', 'Failed to save product types.');
    });
  }

}
